import { FC } from 'react';
import { useRouter } from 'next/router';
import { useCMSPage } from '@belong/contentful/hooks';
import { Skeleton, Stepper, useStepper } from '@belong/ui-components';
import { ResetForm } from './ResetForm';
import { StatusScreen } from './StatusScreen';
import { IResetPasswordContent, IStatusScreenContent } from './types';

const ConfirmationScreen: FC<IStatusScreenContent> = ({ sectionInfoConfirmation, contactUsInfo }) => {
  const { shared } = useStepper<{ email: string; dateOfBirth: string }>();

  return (
    <StatusScreen
      testIdSuffix="confirmation-screen"
      {...shared}
      sectionInfoConfirmation={sectionInfoConfirmation}
      contactUsInfo={contactUsInfo}
    />
  );
};

export const ResetPassword: FC = () => {
  const { data, loading } = useCMSPage<IResetPasswordContent>();
  const content = data?.content;
  const { back } = useRouter();

  if (loading || !content) {
    return <Skeleton />;
  }

  const { resetPasswordForm, resetPasswordSuccess } = content;
  const steps = [ResetForm, ConfirmationScreen];

  return (
    <Stepper steps={steps} onRetreat={back}>
      <ResetForm {...resetPasswordForm} />
      <ConfirmationScreen {...resetPasswordSuccess} />
    </Stepper>
  );
};
